import React from 'react'
import clsx from 'clsx'
import IconWrapper from '@/shared/components/UI/IconWrapper';
import DSpinner from '@/components/Global/DSpinner';

const MainTitle = ({
  Maintitle = '',
  className = '',
  MaintitleClassName = '',
  onClick,
  size = 'sm',
  Icon,
  isLoading = false,
}) =>{

  const sizeClasses = {
    sm: 'text-v3-h4',
    md: 'text-v3-h3',
    lg: 'text-v3-h2',
  }
  return (
     <div className={clsx('flex flex-row items-center gap-v3-ms min-w-0 max-w-full', className)}>
        {Icon && (

            <IconWrapper onClick={onClick} size={24}>
              <div className="bg-v3-purple-primary hover:bg-v3-purple-medium cursor-pointer rounded-full p-[2px] ">
              {Icon}
              </div>
            </IconWrapper>

        )}

         {isLoading ? (
           <div className="min-w-[200px] h-[40px] flex items-center">
             <DSpinner style={{ height: 28, width: 28 }} />
           </div>
         ) : Maintitle && (
           <h1 className={clsx(
             sizeClasses[size],
             'text-v3-black-max font-bolder font-inter-variable truncate min-w-0',
             MaintitleClassName
           )}>
             {Maintitle}
           </h1>
         )}

       </div>
  )
}

export default MainTitle
